import { useRoute } from '@monorepo/tools/src/lib/hooks/tools/use-route';
import styles from './sidebar.module.scss';
import { Icon } from '@monorepo/base/src/components/icon/icon';
import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

interface ISideOpenItemList {
	mini?: boolean;
	title?: JSX.Element | string;
	routeList: string[];
	icon: string;
	color?: string;
	children: React.ReactNode; // the list items to show when expanded
}

export const SideOpenItemList = ({ mini = false, title, routeList, icon, color, children }: ISideOpenItemList) => {
	const { entityRoute } = useRoute();
	const isListActive = routeList.includes(entityRoute);
	const [isOpen, setIsOpen] = useState<boolean>(isListActive);
	const [pos, setPos] = useState<{ top: number; left: number } | null>(null);

	const triggerRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (!isOpen) {
			return;
		}
		updatePos();
		document.addEventListener('scroll', updatePos, true);
		return () => {
			document.removeEventListener('scroll', updatePos, true);
		};
	}, [isOpen]);

	const updatePos = () => {
		const r = triggerRef.current?.getBoundingClientRect();
		if (!r) {
			return;
		}
		setPos({ top: r.top, left: r.right + 21 });
	};

	const handleTabClick = () => {
		// save to local storage with the title as key
		if (!isOpen) {
			updatePos();
		}
		setIsOpen(!isOpen);
	};
	return (
		<li className={`${styles.sideOpenItemWrapper}`}>
			<div
				className={`${styles.itemWrapper} ${isListActive && isOpen ? styles.activeList : isListActive ? styles.activeList : isOpen ? styles.openListSection : ''}`}
				ref={triggerRef}>
				<div className={`${styles.itemLink}`}>
					<div onClick={handleTabClick} className={`${styles.item}`}>
						<Icon className={styles.icon} isMFP color={color} size="18px">
							{icon}
						</Icon>
						{!mini && <span className={styles.itemTitle}>{title}</span>}
						{!mini && (
							<Icon
								className={`${styles.icon} ${styles.sectionListIcon} ${styles.trailingIcon} ${isOpen ? styles.openSectionListIcon : ''}`}
								isMFP
								color={color}
								size="18px">
								chevron-right
							</Icon>
						)}
					</div>
				</div>
			</div>

			{isOpen &&
				pos &&
				createPortal(
					<div className={`${styles.wrapper} ${styles.flyoutWrapper}`} style={{ top: pos.top, left: pos.left }}>
						<ul className={`${styles.list} ${styles.fullList} ${styles.flyoutList}`} onClick={handleTabClick}>
							{children}
						</ul>
					</div>,
					document.body
				)}
		</li>
	);
};
